module.exports = __webpack_public_path__ + "img/banner-v.1fc2b860.png";